import {createHashRouter, createRoutesFromElements, Route} from 'react-router-dom';
import {ROUTES, RouteObject} from './route';

export const router = createHashRouter(
    createRoutesFromElements(
        ROUTES.map((route : RouteObject) => (
            <Route key={route.path} path={route.path} element={route.element}/>
        ))
    )
);